// extracted by mini-css-extract-plugin
export default {"scrollToSite":"dMjksLWi","stick":"Qm_Oj07_","scrolled":"KdNzP6VI","stickLink":"f0mZ3eiI","body":"EDrL6zEb","title":"gcCK6nOV","screenlink":"n5PE3EeB","overlay":"_5FlCuroE"};